import http from '@http';

class AdminAgreementService {
    constructor() {
        if (AdminAgreementService.instance) {
            return AdminAgreementService.instance;
        }
        AdminAgreementService.instance = this;
    }

    getAgreements(language) {
        return http.get('/api/admin/agreements', { params: { language } }).then(res => res.data);
    }

    getAgreement(id, language, version = null) {
        const params = { language };
        if (version !== null) {params.version = version;}
        return http.get(`/api/admin/agreements/${id}`, { params }).then(res => res.data);
    }

    saveAgreement(id, data) {
        return http.post(`/api/admin/agreements/${id}`, data).then(res => res.data);
    }
}

export default new AdminAgreementService();
